// extracted by mini-css-extract-plugin
export var parcelRow = "_u7-0";